// Module
var code = "<md-button class=\"md-icon-button mx-item-chooser-btn\" title=\"{{::vm.internationalization.iconAlt}}\" aria-label=\"{{::vm.internationalization.iconAlt}}\" ng-click=\"vm.toggleDialog(vm.options); $event.stopPropagation();\" role=\"button\">\r\n\t<md-icon role=\"presentation\">{{:: vm.options.icon || 'apps'}}</md-icon>\r\n</md-button>\r\n";
// Exports
export default code;